import React, { Component } from 'react';
import SettingsBlock from 'Components/Common/settingsBlock';
import Switcher from 'Components/Common/switcher';
import 'Styles/otherSettings/otherSettings.scss';
import DeveloperSettingsStore from 'Stores/DeveloperSettingsStore';
import DevelopRequests from 'Utils/Requests/DevelopRequests';
import { observer } from 'mobx-react';
import AppStore from 'Stores/AppStore';

class DeveloperSettings extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Настройки разработчика', 'dev');

        DeveloperSettingsStore.GetSettings();
    }

    render() {
        return (
            <div className='other-settings'>
                <div className='other-settings-settings-container overflowing-element'>

                    <SettingsBlock
                        key="frontCbMode"
                        title='Интерфейс'>
                        <div className='other-settings-line'>
                            <div className='other-settings-title'>Режим ЦБ:</div>
                            <Switcher currentState={DeveloperSettingsStore.settings.frontCbMode}
                                changed={(value) => DeveloperSettingsStore.settings.frontCbMode = (value ? value : null)} />
                        </div>
                    </SettingsBlock>

                    <SettingsBlock
                        key="sync"
                        title='Добавить задержки'>
                        <div className='other-settings-line'>
                            <div className='other-settings-title'>Синхронизация:</div>
                            <Switcher currentState={DeveloperSettingsStore.settings.syncDelays}
                                changed={(value) => DeveloperSettingsStore.settings.syncDelays = value} />
                        </div>
                        <div className='other-settings-line'>
                            <div className='other-settings-title'>Очистка протокола:</div>
                            <Switcher currentState={DeveloperSettingsStore.settings.protocolClearDelays}
                                changed={(value) => DeveloperSettingsStore.settings.protocolClearDelays = value} />
                        </div>
                        <div className='other-settings-line'>
                            <div className='other-settings-title'>Выгрузка документов:</div>
                            <Switcher currentState={DeveloperSettingsStore.settings.documentExportDelays}
                                changed={(value) => DeveloperSettingsStore.settings.documentExportDelays = value} />
                        </div>
                    </SettingsBlock>

                    <SettingsBlock
                        key="stats"
                        title='Статистика'>
                        <div className='other-settings-line'>
                            <button onClick={_ => { DevelopRequests.SaveStats() }} >Сохранить статистику в БД</button>
                        </div>
                    </SettingsBlock>

                </div>
                <div className='settings-buttons-container'>
                    <button className="blue-button"
                        onClick={_ => DeveloperSettingsStore.SaveSettings()}>Сохранить</button>
                </div>
            </div>
        )
    }
}

export default observer(DeveloperSettings);